import React, { Component } from "react";
import { MDBDataTable } from "mdbreact";
import {
  Card,
  CardBody,
  Col,
  Row,
  Button,
  Container,
  Badge,
  Input,
  FormGroup,
  Label,
} from "reactstrap";
import {
  getCouponList,
  toggleCouponStatus,
  deleteCoupon,
} from "../../Endpoint/Admin/index";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { ToastContainer, toast } from "react-toastify";
import { Link } from "react-router-dom";
import ConfirmModal from "../../components/Common/ConfirmModal";

class CouponList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      items: [],
      isLoaded: false,
      statusFilter: "",
      typeFilter: "",
      userTypeFilter: "",
      // Modal states
      showToggleModal: false,
      showDeleteModal: false,
      selectedCouponId: null,
      selectedCouponStatus: null,
      actionLoading: false,
      breadcrumbItems: [
        { title: "Dashboard", link: "/dashboard" },
        { title: "Coupons", link: "#" },
      ],
      tableData: {
        columns: [
          { label: "Code", field: "code", sort: "asc", width: 120 },
          { label: "Name", field: "name", sort: "asc", width: 150 },
          { label: "Type", field: "discountType", sort: "asc", width: 100 },
          { label: "Value", field: "discountValue", sort: "asc", width: 100 },
          { label: "Usage", field: "usage", sort: "asc", width: 100 },
          { label: "Scope", field: "scope", sort: "asc", width: 100 },
          { label: "Validity", field: "validity", sort: "asc", width: 150 },
          { label: "Status", field: "status", sort: "asc", width: 80 },
          { label: "Actions", field: "actions", sort: "disabled", width: 150 },
        ],
        rows: [],
      },
    };
  }

  componentDidMount() {
    this.getAllCoupons();
  }

  getAllCoupons = () => {
    const { statusFilter, typeFilter, userTypeFilter } = this.state;
    const params = {};
    if (statusFilter) params.status = statusFilter;
    // Pass discount type filter correctly
    if (typeFilter && typeFilter !== "") params.discountType = typeFilter;
    // Only pass userTypeFilter if not empty and not the default "All Users" option
    if (userTypeFilter && userTypeFilter !== "") params.userType = userTypeFilter;

    getCouponList(params)
      .then((result) => {
        if (result.status === 200) {
          const rows = result.data.map((coupon) => this.formatCouponRow(coupon));
          this.setState({
            isLoaded: true,
            items: result.data,
            tableData: { ...this.state.tableData, rows },
          });
        } else {
          toast.error(result.message || "Failed to fetch coupons");
        }
      })
      .catch(() => toast.error("Error fetching coupons"));
  };

  formatCouponRow = (coupon) => {
    const now = new Date();
    const startDate = coupon.startDate ? new Date(coupon.startDate) : null;
    const expiryDate = coupon.expiryDate ? new Date(coupon.expiryDate) : null;

    // Determine validity status
    let validityStatus = "active";
    if (startDate && now < startDate) {
      validityStatus = "upcoming";
    } else if (expiryDate && now > expiryDate) {
      validityStatus = "expired";
    }

    const formatDate = (date) => {
      if (!date) return "N/A";
      return new Date(date).toLocaleDateString("en-US", {
        month: "short",
        day: "numeric",
        year: "numeric",
      });
    };

    // Calculate usage - currentUsage is the actual field name from model
    const usedCount = coupon.currentUsage || 0;
    // usageLimit 0 or null means unlimited in the model
    const isUnlimited = coupon.usageLimit === 0 || coupon.usageLimit == null;
    const usageLimitDisplay = isUnlimited ? "∞" : coupon.usageLimit;
    const usagePercentage = !isUnlimited && coupon.usageLimit > 0
      ? Math.round((usedCount / coupon.usageLimit) * 100)
      : 0;

    return {
      code: (
        <span className="font-weight-bold text-primary" style={{ fontFamily: "monospace" }}>
          {coupon.code}
        </span>
      ),
      name: coupon.name,
      discountType: (
        <Badge color={coupon.discountType === "percentage" ? "info" : "success"}>
          {coupon.discountType === "percentage" ? "%" : "$"}
        </Badge>
      ),
      discountValue: (
        <span className="font-weight-bold">
          {coupon.discountType === "percentage"
            ? `${coupon.discountValue}%`
            : `$${coupon.discountValue}`}
          {coupon.uptoAmount && coupon.uptoAmount > 0 && coupon.discountType === "percentage" && (
            <small className="text-muted d-block">
              (max {coupon.uptoAmount})
            </small>
          )}
        </span>
      ),
      usage: (
        <div>
          <span className="font-weight-medium">
            {usedCount} {isUnlimited ? <small className="text-muted">(Unlimited)</small> : `/ ${usageLimitDisplay}`}
          </span>
          {!isUnlimited && coupon.usageLimit > 0 && (
            <div className="progress mt-1" style={{ height: "4px" }}>
              <div
                className={`progress-bar ${usagePercentage >= 90 ? "bg-danger" : usagePercentage >= 70 ? "bg-warning" : "bg-success"}`}
                style={{ width: `${usagePercentage}%` }}
              />
            </div>
          )}
        </div>
      ),
      scope: (
        <Badge color="secondary" className="text-capitalize">
          {coupon.scopeLevel || "all"}
        </Badge>
      ),
      validity: (
        <div>
          <small className="d-block">
            {formatDate(coupon.startDate)} - {formatDate(coupon.expiryDate)}
          </small>
          {validityStatus === "expired" && (
            <Badge color="danger" className="mt-1">Expired</Badge>
          )}
          {validityStatus === "upcoming" && (
            <Badge color="warning" className="mt-1">Upcoming</Badge>
          )}
        </div>
      ),
      status: coupon.isActive ? (
        <Badge color="success">Active</Badge>
      ) : (
        <Badge color="danger">Inactive</Badge>
      ),
      actions: (
        <div className="d-flex">
          <Link to={`/coupon/edit/${coupon._id}`}>
            <Button
              color="primary"
              size="sm"
              className="mr-1 btn-icon"
              title="Edit Coupon"
              style={{ minWidth: "32px", padding: "4px 8px" }}
            >
              <i className="ri-edit-line" style={{ fontSize: "14px" }}></i>
            </Button>
          </Link>
          <Button
            color={coupon.isActive ? "warning" : "success"}
            size="sm"
            className="mr-1 btn-icon"
            onClick={() => this.handleToggleStatus(coupon._id, coupon.isActive)}
            title={coupon.isActive ? "Deactivate" : "Activate"}
            style={{ minWidth: "32px", padding: "4px 8px" }}
          >
            <i
              className={coupon.isActive ? "ri-pause-line" : "ri-play-line"}
              style={{ fontSize: "14px" }}
            ></i>
          </Button>
          <Button
            color="danger"
            size="sm"
            className="btn-icon"
            onClick={() => this.handleDelete(coupon._id)}
            title="Delete Coupon"
            style={{ minWidth: "32px", padding: "4px 8px" }}
          >
            <i className="ri-delete-bin-line" style={{ fontSize: "14px" }}></i>
          </Button>
        </div>
      ),
    };
  };

  // Modal toggle handlers
  toggleToggleModal = () => this.setState({ showToggleModal: !this.state.showToggleModal });
  toggleDeleteModal = () => this.setState({ showDeleteModal: !this.state.showDeleteModal });

  handleToggleStatus = (id, currentStatus) => {
    this.setState({ selectedCouponId: id, selectedCouponStatus: currentStatus, showToggleModal: true });
  };

  confirmToggleStatus = () => {
    const { selectedCouponId, selectedCouponStatus } = this.state;
    const action = selectedCouponStatus ? "deactivate" : "activate";
    this.setState({ actionLoading: true });
    toggleCouponStatus(selectedCouponId)
      .then((response) => {
        if (response.status === 200) {
          toast.success(`Coupon ${action}d successfully`);
          this.getAllCoupons();
        } else {
          toast.error(response.message || `Failed to ${action} coupon`);
        }
      })
      .catch(() => toast.error(`Error ${action}ing coupon`))
      .finally(() => {
        this.setState({ actionLoading: false, showToggleModal: false, selectedCouponId: null, selectedCouponStatus: null });
      });
  };

  handleDelete = (id) => {
    this.setState({ selectedCouponId: id, showDeleteModal: true });
  };

  confirmDelete = () => {
    const { selectedCouponId } = this.state;
    this.setState({ actionLoading: true });
    deleteCoupon(selectedCouponId)
      .then((response) => {
        if (response.status === 200) {
          toast.success("Coupon deleted successfully");
          this.getAllCoupons();
        } else {
          toast.error(response.message || "Failed to delete coupon");
        }
      })
      .catch(() => toast.error("Error deleting coupon"))
      .finally(() => {
        this.setState({ actionLoading: false, showDeleteModal: false, selectedCouponId: null });
      });
  };

  handleFilterChange = (e) => {
    this.setState({ [e.target.name]: e.target.value }, () => {
      this.getAllCoupons();
    });
  };

  render() {
    const { statusFilter, typeFilter, userTypeFilter } = this.state;

    return (
      <React.Fragment>
        <div className="page-content">
          <Container fluid>
            <Breadcrumbs title="Coupon Management" breadcrumbItems={this.state.breadcrumbItems} />

            <Row>
              <Col xs={12}>
                <Card>
                  <CardBody>
                    <div className="d-flex justify-content-between align-items-center mb-4">
                      <h4 className="card-title mb-0">
                        <i className="ri-coupon-3-line mr-2"></i>
                        Coupons
                      </h4>
                      <Link to="/coupon/create">
                        <Button color="primary">
                          <i className="ri-add-line mr-1"></i> Create Coupon
                        </Button>
                      </Link>
                    </div>

                    {/* Filters */}
                    <Row className="mb-4">
                      <Col md={3}>
                        <FormGroup>
                          <Label>Status</Label>
                          <Input
                            type="select"
                            name="statusFilter"
                            value={statusFilter}
                            onChange={this.handleFilterChange}
                          >
                            <option value="">All Status</option>
                            <option value="active">Active</option>
                            <option value="inactive">Inactive</option>
                            <option value="expired">Expired</option>
                          </Input>
                        </FormGroup>
                      </Col>
                      <Col md={3}>
                        <FormGroup>
                          <Label>Discount Type</Label>
                          <Input
                            type="select"
                            name="typeFilter"
                            value={typeFilter}
                            onChange={this.handleFilterChange}
                          >
                            <option value="">All Types</option>
                            <option value="percentage">Percentage</option>
                            <option value="fixed">Fixed Amount</option>
                          </Input>
                        </FormGroup>
                      </Col>
                      <Col md={3}>
                        <FormGroup>
                          <Label>User Type</Label>
                          <Input
                            type="select"
                            name="userTypeFilter"
                            value={this.state.userTypeFilter}
                            onChange={this.handleFilterChange}
                          >
                            <option value="">All Users</option>
                            <option value="all">All Users</option>
                            <option value="first_time">First Time Only</option>
                            <option value="loyalty">Loyalty Users</option>
                          </Input>
                        </FormGroup>
                      </Col>
                    </Row>

                    <MDBDataTable
                      responsive
                      bordered
                      striped
                      hover
                      noBottomColumns
                      data={this.state.tableData}
                      entriesOptions={[10, 25, 50, 100]}
                      entries={10}
                      pagesAmount={4}
                      className="coupon-table"
                    />
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
        {/* Toggle Status Confirmation Modal */}
        <ConfirmModal
          isOpen={this.state.showToggleModal}
          toggle={this.toggleToggleModal}
          onConfirm={this.confirmToggleStatus}
          title={this.state.selectedCouponStatus ? "Deactivate Coupon" : "Activate Coupon"}
          message={`Are you sure you want to ${this.state.selectedCouponStatus ? "deactivate" : "activate"} this coupon?`}
          confirmText={this.state.selectedCouponStatus ? "Deactivate" : "Activate"}
          confirmColor={this.state.selectedCouponStatus ? "warning" : "success"}
          icon={this.state.selectedCouponStatus ? "ri-toggle-line" : "ri-toggle-fill"}
          loading={this.state.actionLoading}
        />

        {/* Delete Confirmation Modal */}
        <ConfirmModal
          isOpen={this.state.showDeleteModal}
          toggle={this.toggleDeleteModal}
          onConfirm={this.confirmDelete}
          title="Delete Coupon"
          message="Are you sure you want to delete this coupon? This action cannot be undone."
          confirmText="Delete"
          confirmColor="danger"
          icon="ri-delete-bin-line"
          loading={this.state.actionLoading}
        />

        <ToastContainer />
      </React.Fragment>
    );
  }
}

export default CouponList;
